import React, { useState, useEffect, useContext, useMemo } from "react";
import { fDMA } from "../../../utils/fecha";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import moment from "moment";

function ComisionesCreate() {
  const { user } = useContext(AuthContext);

  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_ABONOS_FACTURAS = process.env.REACT_APP_URL_ABONOS_FACTURAS;
  const URL_COMISIONES = process.env.REACT_APP_URL_COMISIONES;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;

  const headers = useMemo(
    () => ({
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    }),
    []
  );

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [fecha, setFecha] = useState(hoy);

  const [validaBoton, setValidaBoton] = useState(true);

  // ✅ NUEVO: abonos base (sin filtro)
  const [allBons, setAllBons] = useState([]);

  // ✅ abonos visibles (filtrados por cliente)
  const [inputFieldsBons, setInputFieldsBons] = useState([]);

  // IVA que se descuenta a TODO lo cobrado para sacar la base de comisión,
  // esté facturado o no.
  const IVA_COMISIONES = 0.16;

  const [totalBon, setTotalBon] = useState(0);
  const [totalResumen, setTotalResumen] = useState(0);

  const [porcentaje, setPorcentaje] = useState(0);
  const [total, setTotal] = useState(0);
  const [semanas, setSemanas] = useState(1);
  const [yaPagoPeriodo, setYaPagoPeriodo] = useState(false);

  const [cambioVista, setCambioVista] = useState(0);

  const colaboradorObj = useMemo(
    () => colaboradores.find((x) => x._id === selectedColaborador),
    [colaboradores, selectedColaborador]
  );

  const viaticosSemanaColaborador = Number(colaboradorObj?.viaticosSemana || 0);
  const frecuenciaViaticosColab = colaboradorObj?.frecuenciaViaticos || "Semanal";
  // Comisión pactada con el vendedor en su ficha (Empleados). Se propone al
  // elegirlo y se puede modificar aquí para este pago en concreto.
  const porcentajeColaborador = Number(colaboradorObj?.porcentajeComision || 0);
  // "AntesIVA": la comisión se calcula sobre el importe sin IVA (lo cobrado
  // entre 1.16). "DespuesIVA": sobre el total cobrado tal cual.
  const momentoComision = colaboradorObj?.momentoComision || "AntesIVA";

  // Periodo actual a partir de la fecha y la frecuencia
  const periodoActual = useMemo(() => {
    if (!fecha) return "";
    const [y, m, d] = fecha.split("-").map((x) => Number(x));
    if (frecuenciaViaticosColab === "Mensual") {
      return `${y}-${String(m).padStart(2, "0")}`;
    }
    if (frecuenciaViaticosColab === "Quincenal") {
      return `${y}-${String(m).padStart(2, "0")}-${d <= 15 ? "Q1" : "Q2"}`;
    }
    // Semanal: ISO week
    const date = new Date(Date.UTC(y, m - 1, d));
    const dayNum = (date.getUTCDay() + 6) % 7; // lunes=0
    date.setUTCDate(date.getUTCDate() - dayNum + 3);
    const firstThursday = new Date(Date.UTC(date.getUTCFullYear(), 0, 4));
    const week = Math.round(((date - firstThursday) / 86400000 - 3 + ((firstThursday.getUTCDay() + 6) % 7)) / 7) + 1;
    return `${date.getUTCFullYear()}-W${String(week).padStart(2, "0")}`;
  }, [fecha, frecuenciaViaticosColab]);

  // Viáticos a pagar según frecuencia: el monto del colaborador × semanas
  // (para mensual o quincenal, semanas = períodos)
  const viaticosPeriodo = useMemo(
    () => (yaPagoPeriodo ? 0 : viaticosSemanaColaborador * Number(semanas || 0)),
    [viaticosSemanaColaborador, semanas, yaPagoPeriodo]
  );
  // Ajuste manual a los viáticos: un monto adicional (+) o un descuento (−),
  // con su concepto. Se suma al total de viáticos que se paga.
  const [ajusteViaticos, setAjusteViaticos] = useState("");
  const [conceptoAjuste, setConceptoAjuste] = useState("");
  const ajusteViaticosNum = Number(ajusteViaticos) || 0;
  const viaticosTotal = viaticosPeriodo + ajusteViaticosNum;
  // Ajuste a la comisión misma (bono, penalización, corrección de un pago
  // anterior), con su concepto. Va aparte del ajuste de viáticos porque en el
  // reporte de utilidades la comisión es gasto directo de la venta y los
  // viáticos son gasto general.
  const [ajusteComision, setAjusteComision] = useState("");
  const [conceptoComision, setConceptoComision] = useState("");
  const ajusteComisionNum = Number(ajusteComision) || 0;
  const comisionTotal = Number(total) + ajusteComisionNum;

  // Inputs del Resumen: ancho fijo, alineados a la derecha como los montos
  const estiloInputResumen = {
    width: 160,
    marginLeft: "auto",
    textAlign: "right",
    fontSize: 16,
    fontWeight: 600,
  };

  const [sortField, setSortField] = useState("fecha");
const [sortDirection, setSortDirection] = useState("asc");

  // =========================
  // LOAD: colaboradores + clientes
  // =========================
  useEffect(() => {
    axios
      .get(URL_COLABORADORES, { headers })
      .then((response) => setColaboradores(response.data || []))
      .catch((err) => console.log(err));

    axios
      .get(URL_CLIENTES, { headers })
      .then((response) => setClientes(response.data || []))
      .catch((err) => console.log(err));
  }, [URL_COLABORADORES, URL_CLIENTES, headers]);

  // =========================
  // LOAD: abonos por colaborador
  // =========================
  useEffect(() => {
    // reset si no hay colaborador
    if (!selectedColaborador || selectedColaborador === "0") {
      setAllBons([]);
      setInputFieldsBons([]);
      setTotalBon(0);
      setTotalResumen(0);
      setPorcentaje(0);
      setTotal(0);
      setCambioVista(0);
      return;
    }

   // C5: Comisiones ahora se pagan sobre Surtidos con saldo === 0 (totalmente cobrados).
   axios
  .get(`${URL_SURTIDOS}Colaborador/${selectedColaborador}`, { headers })
  .then((response) => {
    let allBon = response.data || [];

    let arrayTabla = allBon
      .sort((a, b) => (a.idSurtido < b.idSurtido ? 1 : -1))
      .map((a) => {
        const cliente0 = a?.clientes?.[0];
        if (!cliente0) return null;

        const factura0 = a?.facturas?.[0];
        const tieneIVA = Number(a.iva || 0) > 0;

        // La comisión SIEMPRE se calcula sobre el importe sin IVA: a todo lo
        // cobrado se le descuenta el 16% aunque la venta no se haya facturado.
        //   importeConIva = lo que se cobró (total_general)
        //   importe (base) = importeConIva / 1.16
        //   iva            = la diferencia
        const importeConIva = Number(a.total_general || 0);
        // El vendedor define en su ficha si su comisión va antes o después de
        // IVA. Antes: se descuenta el 16% aunque la venta no se haya
        // facturado. Después: se comisiona sobre todo lo cobrado.
        const base =
          momentoComision === "DespuesIVA"
            ? importeConIva
            : importeConIva / (1 + IVA_COMISIONES);
        const iva = importeConIva - base;

        return {
          _id: a._id,
          numero: a.idSurtido,
          fecha: a.fecha,
          clientes: cliente0.nombre_comercial,
          idClientes: cliente0._id,
          factura: factura0
            ? `${factura0.serie || ""}-${factura0.folio || ""}`
            : (a.noFactura || "Sin Factura"),
          importeConIva,
          importe: Number(base.toFixed(2)),
          iva: Number(iva.toFixed(2)),
          tieneIVA,
          // % pactado desde la cotización. 0 = usa el porcentaje general que
          // se captura arriba. Se guarda por renglón porque el acuerdo es
          // por cotización, no por vendedor.
          porcentajePactado: Number(a?.pedidos?.[0]?.comisionPorcentaje || 0),
          comision: 0,
          select: false,
        };
      })
      .filter(Boolean);

    setAllBons(arrayTabla);
    setInputFieldsBons(arrayTabla);


        // Totales al cargar: 0 porque nada seleccionado
        setTotalBon(0);
        setTotalResumen(0);
        // El porcentaje se propone desde la ficha del vendedor; queda
        // editable para ajustarlo en este pago sin tocar su ficha.
        setPorcentaje(porcentajeColaborador);
        setTotal(0);
      })
      .catch((err) => console.log(err));
  }, [selectedColaborador, URL_SURTIDOS, headers, porcentajeColaborador, momentoComision]);

  // Verificar si ya existe Comisión de tipoViaticos=Periodo para el colaborador en el periodoActual
  useEffect(() => {
    if (!selectedColaborador || !periodoActual) {
      setYaPagoPeriodo(false);
      return;
    }
    axios
      .get(`${URL_COMISIONES}/colaborador/${selectedColaborador}`, { headers })
      .then((res) => {
        const lista = res.data || [];
        const existe = lista.some(
          (c) =>
            c.tipoViaticos === "Periodo" && c.periodoViaticos === periodoActual
        );
        setYaPagoPeriodo(existe);
      })
      .catch((err) => {
        console.log(err);
        setYaPagoPeriodo(false);
      });
  }, [selectedColaborador, periodoActual, URL_COMISIONES, headers]);

  // =========================
  // ✅ FILTRO: por cliente (front)
  // =========================
  useEffect(() => {
    // Mantener selección? aquí lo reseteamos por seguridad contable
    const resetRows = (rows) =>
      (rows || []).map((r) => ({ ...r, select: false, comision: 0 }));

    if (!selectedCliente || selectedCliente === "0") {
      setInputFieldsBons(resetRows(allBons));
    } else {
      const filtrados = allBons.filter((b) => b.idClientes === selectedCliente);
      setInputFieldsBons(resetRows(filtrados));
    }

    // Reset totales y comisión
    setTotalBon(0);
    setTotalResumen(0);
    setPorcentaje(0);
    setTotal(0);
  }, [selectedCliente, allBons]);

  // =========================
  // HELPERS
  // =========================
  const moneyUSD = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(v || 0));

  function ActualizaTotalesBons(nextRows = inputFieldsBons) {
    let activos = (nextRows || []).filter((e) => e.select === true);
    let TB = activos.reduce((acc, r) => acc + Number(r.importe || 0), 0);

    setTotalBon(TB);
    setTotalResumen(TB);

    // El total es la suma de las comisiones renglón por renglón, no una
    // regla de tres sobre la base: cada cotización puede traer su propio %.
    setTotal(activos.reduce((t, r) => t + Number(r.comision || 0), 0));
  }

  // El porcentaje que aplica a un renglón: el pactado en su cotización si lo
  // hay, si no el general capturado arriba.
  // Precedencia: % pactado en la cotización > % especial del cliente > % general.
  const pctPorCliente = (idCliente) => {
    const lista = colaboradorObj?.comisionesPorCliente || [];
    const hit = lista.find(
      (c) => String(c?.clientes?._id || c?.clientes || "") === String(idCliente || "")
    );
    return hit ? Number(hit.porcentaje || 0) : 0;
  };
  const pctDe = (r, general) => {
    if (Number(r?.porcentajePactado) > 0) return Number(r.porcentajePactado);
    const especial = pctPorCliente(r?.idClientes);
    if (especial > 0) return especial;
    return Number(general || 0);
  };

  function calculaComision(val) {
    const p = Number(val || 0);
    setPorcentaje(p);

    // Recalcula cada renglón seleccionado con SU porcentaje: los que tienen
    // acuerdo propio no se mueven al cambiar el general.
    const next = inputFieldsBons.map((r) => ({
      ...r,
      comision: r.select ? (Number(r.importe || 0) * pctDe(r, p)) / 100 : 0,
    }));
    setInputFieldsBons(next);
    const suma = next.reduce((t, r) => t + Number(r.comision || 0), 0);
    setTotal(suma);
  }

  function toggleRowPago(rowId, checked) {
    const p = Number(porcentaje || 0);

    const next = inputFieldsBons.map((r) => {
      if (r._id !== rowId) return r;

      const select = !!checked;
      return {
        ...r,
        select,
        comision: select ? (Number(r.importe || 0) * pctDe(r, p)) / 100 : 0,
      };
    });

    setInputFieldsBons(next);
    ActualizaTotalesBons(next);
  }

  // Selecciona / deselecciona TODAS las ventas listadas de un golpe.
  function toggleTodasPago(checked) {
    const p = Number(porcentaje || 0);
    const select = !!checked;
    const next = inputFieldsBons.map((r) => ({
      ...r,
      select,
      comision: select ? (Number(r.importe || 0) * pctDe(r, p)) / 100 : 0,
    }));
    setInputFieldsBons(next);
    ActualizaTotalesBons(next);
  }

  // ¿están todas seleccionadas? (para el estado del checkbox del encabezado)
  const todasSeleccionadas =
    inputFieldsBons.length > 0 && inputFieldsBons.every((r) => r.select === true);

  // W13: editar comisión específica de una venta (sobrescribe el % global)
  function editComisionRow(rowId, value) {
    const v = parseFloat(value) || 0;
    const next = inputFieldsBons.map((r) =>
      r._id === rowId ? { ...r, comision: v, select: v > 0 } : r
    );
    setInputFieldsBons(next);
    ActualizaTotalesBons(next);
  }

  // =========================
  // SAVE
  // =========================
  function savePago() {
    const p = Number(porcentaje || 0);
    if (!p) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes capturar el Porcentaje",
      });
      return;
    }

    const seleccionados = inputFieldsBons.filter((a) => a.select === true);
    if (!seleccionados.length) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Debes seleccionar al menos un Abono",
      });
      return;
    }

    if (ajusteComisionNum !== 0 && !String(conceptoComision || "").trim()) {
      Swal.fire({
        icon: "error",
        title: "Falta el concepto",
        text: "Escribe el concepto del ajuste de comisión",
      });
      return;
    }
    if (ajusteViaticosNum !== 0 && !String(conceptoAjuste || "").trim()) {
      Swal.fire({
        icon: "error",
        title: "Falta el concepto",
        text: "Escribe el concepto del ajuste de viáticos",
      });
      return;
    }
    if (comisionTotal + Number(viaticosTotal) < 0) {
      Swal.fire({
        icon: "error",
        title: "Total negativo",
        text: `Los ajustes dejan el total a pagar en ${moneyUSD(
          comisionTotal + Number(viaticosTotal)
        )}. El descuento no puede ser mayor que comisión + viáticos.`,
      });
      return;
    }

    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará el pago",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      try {
        toggleProgreso();
        setValidaBoton(false);

        // 1) crear comisión
        const comRes = await axios.post(
          `${URL_COMISIONES}`,
          {
            fecha,
            importe: comisionTotal + Number(viaticosTotal),
            colaboradores: selectedColaborador,
            porcentaje: p,
            total: totalResumen,
            viaticos: viaticosTotal,
            semanas: Number(semanas || 0),
            tipoViaticos: "Periodo",
            // El período solo se marca como pagado si de verdad se pagaron los
            // viáticos del período (no si solo hubo un ajuste)
            periodoViaticos: viaticosPeriodo > 0 ? periodoActual : "",
            concepto: "Comisiones",
            comisionAjuste: ajusteComisionNum,
            conceptoComisionAjuste: ajusteComisionNum !== 0 ? String(conceptoComision).trim() : "",
            viaticosAjuste: ajusteViaticosNum,
            conceptoAjuste: ajusteViaticosNum !== 0 ? String(conceptoAjuste).trim() : "",
          },
          { headers }
        );

        const comisionId = comRes?.data?._id;

        // 2) marcar surtidos seleccionados como comisión pagada
        await Promise.all(
          seleccionados.map((a) =>
            axios.patch(
              `${URL_SURTIDOS}Comision/${a._id}`,
              { comisiones: comisionId },
              { headers }
            )
          )
        );

        // 3) log
        await axios.post(
          URL_LOGS,
          {
            tipo: "Pagar Comisiones",
            detalle: `Fecha: ${fecha} Vendedor: ${selectedColaborador}`,
            user: user?.id,
          },
          { headers }
        );

        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => window.location.reload(), 900);
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      } finally {
        // cerrar modal progreso si quedó abierto
        setModalProgreso(false);
      }
    });
  }

  function handleSort(field) {
  if (sortField === field) {
    // si ya está seleccionado → invierte
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
  } else {
    // si es nuevo campo → asc por default
    setSortField(field);
    setSortDirection("asc");
  }
}

const sortedBons = useMemo(() => {
  let sorted = [...inputFieldsBons];

  sorted.sort((a, b) => {
    let valA = a[sortField];
    let valB = b[sortField];

    // 🔹 FECHA
    if (sortField === "fecha") {
      valA = new Date(valA);
      valB = new Date(valB);
    }

    // 🔹 STRING (cliente)
    if (typeof valA === "string") {
      const res = valA.localeCompare(valB, "es", { sensitivity: "base" });
      return sortDirection === "asc" ? res : -res;
    }

    // 🔹 NUMEROS
    return sortDirection === "asc"
      ? valA - valB
      : valB - valA;
  });

  return sorted;
}, [inputFieldsBons, sortField, sortDirection]);
  return (
    <>
      <Header />
      <br />
      <br />

      {user?.comisionesCreate ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={8}>
                    <Button
                      size="sm"
                      href="/ListadoComisiones"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Col>
                </Row>

                <br />
                <h3 align="center">Comisiones Vendedor</h3>

                {cambioVista === 0 ? (
                  <>
                    <Row>
                      <Col md={2}>
                        <Label>Vendedor</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={selectedColaborador}
                          onChange={(e) => {
                            setSelectedColaborador(e.target.value);
                            setSelectedCliente("0"); // reset cliente al cambiar vendedor
                          }}
                        >
                          <option value="0">Selecciona</option>
                          {colaboradores
                          .filter((a) => a.vendedor === "Si")
                          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                          .map((a) => {
                              return (
                                <option key={a._id} value={a._id}>
                                  {a.nombre} {a.apellido}
                                </option>
                              );
                          })}
                        </Input>
                      </Col>

                      <Col md={2}>
                        <Label>Cliente</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={selectedCliente}
                          onChange={(e) => setSelectedCliente(e.target.value)}
                          disabled={!selectedColaborador || selectedColaborador === "0"}
                        >
                          <option value="0">Selecciona</option>
                          {clientes
                            .slice()
                            .sort((a, b) =>
                              a.nombre_comercial > b.nombre_comercial ? 1 : -1
                            )
                            .map((a) => (
                              <option key={a._id} value={a._id}>
                                {a.nombre_comercial}
                              </option>
                            ))}
                        </Input>
                      </Col>

                      <Col md={8}>
                        <ButtonGroup id="logoutBoton">
                          {cambioVista > 0 ? (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              onClick={() => {
                                setCambioVista(cambioVista - 1);
                                setTotalResumen(totalBon);
                              }}
                            >
                              Regresar
                            </Button>
                          ) : (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              disabled
                            >
                              Regresar
                            </Button>
                          )}

                          {selectedColaborador && selectedColaborador !== "0" ? (
                            <Button
                              color="danger"
                              size="sm"
                              className="btn btn-success"
                              onClick={() => {
                                setCambioVista(cambioVista + 1);
                                setTotalResumen(totalBon);
                              }}
                            >
                              Continuar
                            </Button>
                          ) : (
                            <Button
                              color="danger"
                              size="sm"
                              className="btn btn-success"
                              disabled
                            >
                              Continuar
                            </Button>
                          )}

                          {validaBoton && cambioVista === 1 ? (
                            <Button
                              color="success"
                              className="btn btn-success"
                              size="sm"
                              onClick={savePago}
                            >
                              Guardar
                            </Button>
                          ) : (
                            <Button
                              color="success"
                              type="submit"
                              className="btn btn-success"
                              size="sm"
                              disabled
                            >
                              Guardar
                            </Button>
                          )}
                        </ButtonGroup>
                      </Col>
                    </Row>

                    <br />
                    <h4>Abonos</h4>

                    {inputFieldsBons.length > 0 ? (
                      <Table striped borderless>
                        <thead>
  <tr>
    <th style={{ cursor: "pointer" }} onClick={() => handleSort("fecha")}>
      Fecha {sortField === "fecha" ? (sortDirection === "asc" ? "↑" : "↓") : ""}
    </th>

    <th>Abono</th>

    <th style={{ cursor: "pointer" }} onClick={() => handleSort("clientes")}>
      Cliente {sortField === "clientes" ? (sortDirection === "asc" ? "↑" : "↓") : ""}
    </th>

    <th>Importe</th>
    <th>Iva</th>
    <th>Base</th>
    <th title="Porcentaje con el que se calcula cada venta">% Comisión</th>
    <th>Comision</th>
    <th align="center">
      Pagar
      <br />
      <Input
        type="checkbox"
        title={todasSeleccionadas ? "Quitar todas" : "Seleccionar todas"}
        checked={todasSeleccionadas}
        onChange={(e) => toggleTodasPago(e.target.checked)}
        style={{ position: "static", marginLeft: 0 }}
      />
    </th>
  </tr>
</thead>
                        <tbody>
                          {sortedBons
                          // .sort((a, b) => (a.fecha > b.fecha ? 1 : -1))
                          .map((a) => (
                            <tr key={a._id}>
                              <td>{fDMA(a.fecha)}</td>
                              <td>{a.numero}</td>
                              <td>{a.clientes}</td>
                              <td>{moneyUSD(a.importeConIva)}</td>
                              <td>{moneyUSD(a.iva)}</td>
                              <td>{moneyUSD(a.importe)}</td>
                              <td>
                                {Number(a.porcentajePactado) > 0 ? (
                                  <span
                                    style={{ color: "#b8860b", fontWeight: 600 }}
                                    title="Comisión especial pactada en la cotización"
                                  >
                                    {a.porcentajePactado}% <small>(cotización)</small>
                                  </span>
                                ) : pctPorCliente(a.idClientes) > 0 ? (
                                  <span
                                    style={{ color: "#1e7e34", fontWeight: 600 }}
                                    title="Comisión especial de este cliente (ficha del vendedor)"
                                  >
                                    {pctPorCliente(a.idClientes)}% <small>(cliente)</small>
                                  </span>
                                ) : Number(porcentaje) > 0 ? (
                                  // El general: el que se captura abajo
                                  `${Number(porcentaje)}%`
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>{moneyUSD(a.comision)}</td>
                              <td>
                                <Input
                                  type="checkbox"
                                  checked={!!a.select}
                                  onChange={(e) =>
                                    toggleRowPago(a._id, e.target.checked)
                                  }
                                />
                              </td>
                            </tr>
                          ))}

                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className="negrita" align="center">
                              Total
                            </td>
                            <td className="negrita">{moneyUSD(totalBon)}</td>
                            <td></td>
                            <td className="negrita">
                              {moneyUSD(
                                sortedBons.reduce(
                                  (t, r) => t + Number(r.comision || 0),
                                  0
                                )
                              )}
                            </td>
                            <td></td>
                          </tr>
                        </tbody>
                      </Table>
                    ) : (
                      <h4>No se encontraron Movimientos....</h4>
                    )}
                  </>
                ) : (
                  <>
                    <Row>
                      <Col md={2}>
                        <Label>Vendedor</Label>
                        <Input
                          bsSize="sm"
                          type="select"
                          value={selectedColaborador}
                          disabled
                        >
                          <option value="0">Selecciona</option>
                          {colaboradores
                            .filter((a) => a.vendedor === "Si")
                            .map((a) => {
                              return (
                                <option key={a._id} value={a._id}>
                                  {a.nombre} {a.apellido}
                                </option>
                              );
                            })}
                        </Input>
                      </Col>

                      <Col md={10}>
                        <ButtonGroup id="logoutBoton">
                          {cambioVista > 0 ? (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              onClick={() => {
                                setCambioVista(cambioVista - 1);
                                setTotalResumen(totalBon);
                              }}
                            >
                              Regresar
                            </Button>
                          ) : (
                            <Button
                              color="info"
                              size="sm"
                              className="btn btn-success"
                              disabled
                            >
                              Regresar
                            </Button>
                          )}

                          <Button
                            color="danger"
                            size="sm"
                            className="btn btn-success"
                            disabled
                          >
                            Continuar
                          </Button>

                          {validaBoton && cambioVista === 1 ? (
                            <Button
                              color="success"
                              className="btn btn-success"
                              size="sm"
                              onClick={savePago}
                            >
                              Guardar
                            </Button>
                          ) : (
                            <Button
                              color="success"
                              type="submit"
                              className="btn btn-success"
                              size="sm"
                              disabled
                            >
                              Guardar
                            </Button>
                          )}
                        </ButtonGroup>
                      </Col>
                    </Row>

                    <br />

                    <div className="card container col-sm-5">
                      <h4 style={{ fontWeight: "bold" }}>Resumen</h4>
                      <Table>
                        <tbody>
                          <tr>
                            <th>Total</th>
                            <td align="right">{moneyUSD(totalResumen)}</td>
                          </tr>

                          <tr>
                            <th>
                              Porcentaje
                              {porcentajeColaborador > 0 ? (
                                <span style={{ fontWeight: 400, fontSize: 12, color: "#666", marginLeft: 6 }}>
                                  (ficha: {porcentajeColaborador}% ·{" "}
                                  {momentoComision === "DespuesIVA" ? "después de IVA" : "antes de IVA"})
                                </span>
                              ) : (
                                <span style={{ fontWeight: 400, fontSize: 12, color: "#b8860b", marginLeft: 6 }}>
                                  (sin % en su ficha)
                                </span>
                              )}
                            </th>
                            <td align="right">
                              <Input
                                type="number"
                                min="0"
                                step="any"
                                value={porcentaje}
                                onChange={(e) =>
                                  calculaComision(e.target.value)
                                }
                                style={estiloInputResumen}
                              />
                            </td>
                          </tr>

                          <tr>
                            <th>Comision</th>
                            <td align="right">{moneyUSD(total)}</td>
                          </tr>

                          <tr>
                            <th>
                              Ajuste comisión
                              <span style={{ fontWeight: 400, fontSize: 12, color: "#666", marginLeft: 6 }}>
                                (+ bono / − descuento)
                              </span>
                            </th>
                            <td align="right">
                              <Input
                                type="number"
                                step="any"
                                placeholder="0.00"
                                value={ajusteComision}
                                onChange={(e) => setAjusteComision(e.target.value)}
                                style={{
                                  ...estiloInputResumen,
                                  color: ajusteComisionNum < 0 ? "#c00" : ajusteComisionNum > 0 ? "#080" : undefined,
                                }}
                              />
                            </td>
                          </tr>

                          {ajusteComisionNum !== 0 && (
                            <>
                              <tr>
                                <th>Concepto del ajuste</th>
                                <td align="right">
                                  <Input
                                    type="text"
                                    placeholder="Ej. bono por meta, descuento por nota cancelada…"
                                    value={conceptoComision}
                                    onChange={(e) => setConceptoComision(e.target.value)}
                                    invalid={!String(conceptoComision || "").trim()}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <th>Comisión total</th>
                                <td align="right" style={{ fontWeight: 600 }}>
                                  {moneyUSD(comisionTotal)}
                                </td>
                              </tr>
                            </>
                          )}

                          <tr>
                            <th>Viaticos / Semana</th>
                            <td align="right">{moneyUSD(viaticosSemanaColaborador)}</td>
                          </tr>

                          <tr>
                            <th>Semanas</th>
                            <td align="right">
                              <Input
                                type="number"
                                min="0"
                                step="1"
                                value={semanas}
                                onChange={(e) => setSemanas(e.target.value)}
                                style={estiloInputResumen}
                              />
                            </td>
                          </tr>

                          <tr>
                            <th>
                              Ajuste viáticos
                              <span style={{ fontWeight: 400, fontSize: 12, color: "#666", marginLeft: 6 }}>
                                (+ adicional / − descuento)
                              </span>
                            </th>
                            <td align="right">
                              <Input
                                type="number"
                                step="any"
                                placeholder="0.00"
                                value={ajusteViaticos}
                                onChange={(e) => setAjusteViaticos(e.target.value)}
                                style={{
                                  ...estiloInputResumen,
                                  color: ajusteViaticosNum < 0 ? "#c00" : ajusteViaticosNum > 0 ? "#080" : undefined,
                                }}
                              />
                            </td>
                          </tr>

                          {ajusteViaticosNum !== 0 && (
                            <tr>
                              <th>Concepto del ajuste</th>
                              <td align="right">
                                <Input
                                  type="text"
                                  placeholder="Ej. gasolina extra, viaje a Puebla, descuento por anticipo…"
                                  value={conceptoAjuste}
                                  onChange={(e) => setConceptoAjuste(e.target.value)}
                                  invalid={!String(conceptoAjuste || "").trim()}
                                />
                              </td>
                            </tr>
                          )}

                          <tr>
                            <th>
                              Viaticos Total
                              {ajusteViaticosNum !== 0 && (
                                <span style={{ fontWeight: 400, fontSize: 12, color: "#666", marginLeft: 6 }}>
                                  ({moneyUSD(viaticosPeriodo)} {ajusteViaticosNum > 0 ? "+" : "−"}{" "}
                                  {moneyUSD(Math.abs(ajusteViaticosNum))})
                                </span>
                              )}
                              {yaPagoPeriodo && (
                                <span
                                  style={{
                                    color: "#c00",
                                    fontSize: 11,
                                    marginLeft: 6,
                                  }}
                                >
                                  (Ya pagado en este período: {periodoActual})
                                </span>
                              )}
                            </th>
                            <td align="right">{moneyUSD(viaticosTotal)}</td>
                          </tr>

                          <tr>
                            <th>Total a Pagar</th>
                            <td style={{ fontWeight: "bold" }} align="right">
                              {moneyUSD(comisionTotal + Number(viaticosTotal))}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default ComisionesCreate;
